import * as Yup from "yup";
import formData from "./formData";
import { EvaluationPermissions, EvaluationScore, EvaluationStatus } from "../../../common/Evaluation";

const {
  formField: { assessor1CommentHelper, assessor2CommentHelper, finalReviewerCommentHelper, evaluateeCommentHelper: seniorOfficerCommentHelper },
} = formData;

const validationSchema = Yup.object().shape({
  [assessor1CommentHelper.name]: Yup.string().when(["scores", "status", "permissions"], {
    is: (scores: EvaluationScore[], status: EvaluationStatus, permissions: EvaluationPermissions) =>
      (status === EvaluationStatus.EVALUATION_INITIATED ||
        status === EvaluationStatus.ASSESSOR_1_EDIT ||
        status === EvaluationStatus.ASSESSOR_2_RETURN) &&
      permissions.assessor1 &&
      scores?.some((score) => score?.score === 1 || score?.score === 5),
    then: (schema) =>
      schema.required("Comments are required if a score of 1 or 5 is present.").max(5000, 'Comments must be at most 5000 characters.'),
    otherwise: (schema) => schema.notRequired().max(5000, 'Comments must be at most 5000 characters.'),
  }),

  [assessor2CommentHelper.name]: Yup.string().notRequired().max(5000, 'Comments must be at most 5000 characters.'),
  [finalReviewerCommentHelper.name]: Yup.string().notRequired().max(5000, 'Comments must be at most 5000 characters.'),
  [seniorOfficerCommentHelper.name]: Yup.string().notRequired().max(5000, 'Comments must be at most 5000 characters.')
});

export default validationSchema;
